var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReportIcon = function SvgReportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M3.863 1.5v15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M3.863 3h8.4c2.025 0 2.475 1.125 1.05 2.55l-.9.9c-.6.6-.6 1.575 0 2.1l.9.9c1.425 1.425.9 2.55-1.05 2.55h-8.4",
    opacity: 0.34
  })));
};
export default SvgReportIcon;